import React, { useEffect, useState, useRef } from "react";
import "../style/weatherCard.css";
// style for icons of weather-icons
import "weather-icons/css/weather-icons.css";
import InfoPopup from "./infoPopup";

function WeatherCard({ data }) {
  const [backgroundImg, setBackgroundImg] = useState({});
  // const [infoPopup, setInfoPopup] = useState(false);
  const [selectedInfo, setSelectedInfo] = useState(null);
  const dateRefs = useRef({});

  // new map of icons from weather-icons
  const iconMapping = {
    "01d": "wi-day-sunny",
    "01n": "wi-night-clear",
    "02d": "wi-day-cloudy",
    "02n": "wi-night-alt-cloudy",
    "03d": "wi-cloud",
    "03n": "wi-cloud",
    "04d": "wi-cloudy",
    "04n": "wi-cloudy",
    "09d": "wi-showers",
    "09n": "wi-showers",
    "10d": "wi-day-rain",
    "10n": "wi-night-alt-rain",
    "11d": "wi-thunderstorm",
    "11n": "wi-thunderstorm",
    "13d": "wi-snow",
    "13n": "wi-snow",
    "50d": "wi-fog",
    "50n": "wi-fog",
  };

  // Function to convert time in hour
  const convertTime = (timeUtc, timeZone) => {
    const date = new Date((timeUtc + timeZone) * 1000);
    const localOffset = date.getTimezoneOffset() * 60;
    const localDate = new Date((timeUtc + timeZone + localOffset) * 1000);
    const timeOptions = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    };
    return localDate.toLocaleTimeString([], timeOptions);
  };

  // Variables to obtain info from data
  const sunrise = data.city.sunrise;
  const sunset = data.city.sunset;
  // const city = data.city.name;
  const timeZone = data.city.timezone;
  const localSunrise = convertTime(sunrise, timeZone);
  const localSunset = convertTime(sunset, timeZone);

  // Function to obtain hour from dt_txt
  const getHourFromDtTxt = (parameterTxt) => {
    return parameterTxt.split(" ")[1].substring(0, 5);
  };

  // Function to transform m/s in km/h
  const convertMsToKmH = (parameterMs) => {
    return (parameterMs * 3.6).toFixed(1);
  };

  // Function to convert date
  const convertDate = (parameters) => {
    const date = new Date(parameters * 1000);
    const options = {
      month: "long",
      weekday: "short",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };

  // Function to organize date with forecast
  const organizeForecastByDate = (forecastList) => {
    return forecastList.reduce((acc, forecast) => {
      const date = convertDate(forecast.dt);
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(forecast);
      return acc;
    }, {});
  };

  const organizedData = organizeForecastByDate(data.list);

  // obtain first day from data
  const firstDaynumber = new Date(Object.keys(organizedData)[0]).getDate();
  const [selectedDay, setSelectedDay] = useState(firstDaynumber);

  // Function to convert temperature kelvin to celsius
  const celsius = (parameterKelvin) => {
    return (parameterKelvin - 273.15).toFixed(1);
  };

  // Function to use img day or night
  const loadImgDay = (parameter) => {
    const imgMap = {
      Clouds: "cloud.jpg",
      Rain: "rain.jpg",
      Clear: "clear.jpg",
    };
    return `/media/weatherImgDay/${imgMap[parameter] || "default.jpg"}`;
  };

  const loadImgNight = (parameter) => {
    const imgMap = {
      Clouds: "cloud.jpg",
      Rain: "rain.jpg",
      Clear: "clear.jpg",
    };
    return `/media/weatherImgNight/${imgMap[parameter] || "default.jpg"}`;
  };

  // function to use folder for day or for night
  const fixedHourDay = 6;
  const fixedHourNight = 18;

  useEffect(() => {
    const newBackgroundImg = {};
    data.list.forEach((el) => {
      const hour = parseInt(getHourFromDtTxt(el.dt_txt).split(":")[0], 10);
      if (hour >= fixedHourNight || hour < fixedHourDay) {
        newBackgroundImg[el.dt] = loadImgNight(el.weather[0].main);
      } else {
        newBackgroundImg[el.dt] = loadImgDay(el.weather[0].main);
      }
    });
    setBackgroundImg(newBackgroundImg);
  }, [data]);

  // function to scrool into the date select
  const handleScroll = (parameter) => {
    setSelectedDay(parameter);
    const dateKey = Object.keys(organizedData).find(
      (date) => new Date(date).getDate() === parameter
    );
    if (dateRefs.current[dateKey]) {
      // calc the position of element rispect of document
      const element = dateRefs.current[dateKey];
      const offsetTop = element.getBoundingClientRect().top + window.scrollY;

      // Scroll until the position of element minus the offset in pixel
      const offsetPixels = 200;
      window.scrollTo({
        top: offsetTop - offsetPixels,
        behavior: "smooth",
      });
    }
  };

  const openInfo = (info) => {
    setSelectedInfo(info);
  };
  const closeInfo = () => {
    setSelectedInfo(null);
  };

  return (
    <div className="cardContainer">
      <div className="motherCard">
        <div className="titleAndDayNumber">
          <div className="title">
            <div className="iconSurnriseSunsetContainer">
              <img src="/media/icons/sunrise.png" alt="logo of sunrise" />
              <h1>{localSunrise}</h1>
            </div>
            <div className="iconSurnriseSunsetContainer">
              <h1>{localSunset}</h1>
              <img src="/media/icons/sunset.png" alt="logo of sunset" />
            </div>
          </div>
          <div className="dayNumber">
            {Object.keys(organizedData).map((date) => {
              const dayNumber = new Date(date).getDate();
              return (
                <div
                  key={date}
                  className={
                    selectedDay === dayNumber ? "numberOnView" : "numberDefault"
                  }
                  onClick={() => handleScroll(dayNumber)}
                >
                  <p>{selectedDay === dayNumber ? date : dayNumber}</p>
                </div>
              );
            })}
          </div>
        </div>
        <div className="dateForecast">
          {Object.keys(organizedData).map((date) => (
            <div
              key={date}
              className="forecastContainer"
              ref={(el) => (dateRefs.current[date] = el)}
            >
              <h3 className="styleForDayTitle">{date}</h3>
              <div className="singleForecastCard">
                {organizedData[date].map((el) => {
                  const hour = parseInt(getHourFromDtTxt(el.dt_txt));
                  const dateTime =
                    hour >= fixedHourNight || hour < fixedHourDay;
                  return (
                    <div
                      onClick={() => openInfo(el)}
                      key={el.dt}
                      className="forecast"
                    >
                      {selectedInfo && selectedInfo.dt_txt === el.dt_txt && (
                        <InfoPopup
                          generalData={data}
                          singleInfo={selectedInfo}
                          switchInfo={closeInfo}
                          hour={getHourFromDtTxt(el.dt_txt)}
                          date={date}
                          celsius={celsius}
                        />
                      )}
                      <div
                        className={dateTime ? "forecastNight" : "forecastDay"}
                        style={{
                          backgroundImage: `url(${backgroundImg[el.dt]})`,
                          // backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      >
                        <div className="hourTempContainer">
                          <div>
                            <h3>{getHourFromDtTxt(el.dt_txt)}</h3>
                          </div>
                        </div>
                      </div>
                      <div className="forecastRight">
                        <div>
                          <h2>{celsius(el.main.temp)}C° </h2>
                          <h5>p: {celsius(el.main.feels_like)}C°</h5>
                        </div>
                        <div className="iconContainer">
                          <i
                            className={`wi ${iconMapping[el.weather[0].icon]}`}
                            style={{ fontSize: "25px" }}
                          ></i>
                          <p className="fontMediaQuery">
                            Rain {(el.pop * 100).toFixed(0)}%
                          </p>
                        </div>
                        <div className="iconContainer">
                          <img
                            className="imgIcon"
                            src="/media/icons/humidity3.png"
                            alt="Humidity icon"
                          />

                          <p className="fontMediaQuery">
                            h. {el.main.humidity}%
                          </p>
                        </div>
                        <div className="iconContainer">
                          <img
                            className="imgIcon"
                            src="/media/icons/windArrowDown.png"
                            alt="Wind arrow"
                            style={{ rotate: `${el.wind.deg}deg` }}
                          />
                          <p className="fontMediaQuery" translate="no">
                            {convertMsToKmH(el.wind.speed)}km/h
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WeatherCard;

// Old metod used icons from API openweather
// {/* <i
//                               src={`https://openweathermap.org/img/wn/${el.weather[0].icon}@2x.png`}
//                               alt={el.weather.description}
//                             ></i> */}
